export var NodeEnv = {
    development: 'development',
    production: 'production',
};
export var DOMAIN = {
    beta: 'test',
    gamma: 'test',
    prod: 'prod',
};
export var REALM = {
    'eu-west-1': 'EUAmazon',
    'us-east-1': 'USAmazon',
    'us-west-2': 'FEAmazon',
};
var EU_MARKETPLACE_IDS = new Set([
    'A1F83G8C2ARO7P',
    'A1PA6795UKMFR9',
    'A13V1IB3VIYZZH',
    'A1RKKUPIHCS9HS',
    'APJ6JRA9NG5V4',
    'A17E79C6D8DWNP',
    'A1805IZSGTT6HS',
    'A2VIGQ35RCS4UG',
    'A33AVAJ2PDY3EV',
    'A2NODRKZP88ZB9',
    'ARBP9OOSHTCHU',
    'A1C3SOZRARQ6R3',
    'AMEN7PMS3EDWL',
    'AE08WJ6YKNBMC',
    'A21TJRUUN4KGV',
    'A28R8C7NBKEWEA',
    'A3O7FHSIRK2OV3',
    'A3E73JPODXHKAF',
    'A3VBN6V9A9URK0',
    'A25WV6Y4IVTZE8',
    'A1NYP31CE519TD',
    'A2UKSUQDE5MTXV',
    'A2RPXXAS5KYK9A',
    'A1JSMXFPCIAY1L',
    'A3NQNU31RX5UE5',
    'A10M1MMMNRBMCB',
    'AAQMAU3NQ28UF',
    'A3BP1YT063BUWS',
    'A1FG4BLCBHACWL',
    'ACUG9OPS7I0O8',
    'A3HX2EACAZT9OW',
    'A29118EZBHT1Z3',
    'A34GYYCZVDBSIK',
    'A1YFOMBPFBRY22',
    'A2XZLSVIQ0F4JT',
    'A3HOBANJMCMD83',
    'A1M3WC0SJ3A38T',
    'AKY4K4WKH21YQ',
    'A1MQPSGJ6U9Q54',
    'AT614YYYNOC1S',
    'A3CQBQD3RGPJR8',
    'A3TFQ1G9L8TQ5L',
    'AQGJ466SKA0F0',
    'AJZF8LZ1EJVJN',
    'AUJPM9XGFJRC7',
    'A1BQ60DSEH8GT1',
    'A1PQYARCGWBR4W',
    'A2V81V561I22JC',
    'A11TF4OR7D7IB3',
    'A1XA2X4RM2R9UJ',
    'A4FDTIXZTF29G',
    'A35ZCMMKG26PR6',
    'A1RBL38K01OUS8',
    'A3LUBJS0LU6F7R',
    'A3GKB3741847US',
    'A1XYRYBMFX5RJA',
    'A4GEHQSF0VK8I',
    'A3JYXYQQW6O8II',
    'A3Q9C6SGRQ0E3K',
    'A1ROW8Y7WZ6O4R',
    'A2R2JSZFAABXX' // IE Score Beta
]);
/**
 * Copied over all the relevant marketplaces from AMCConfigBank which contains all valid ads-console marketplaces:
 * 1. https://code.amazon.com/packages/AMCConfigBank/blobs/mainline/--/configuration/configs/Common/beta.json
 * 2. https://code.amazon.com/packages/AMCConfigBank/blobs/mainline/--/configuration/configs/Common/gamma.json
 * 3. https://code.amazon.com/packages/AMCConfigBank/blobs/mainline/--/configuration/configs/Common/prod.json
 * @param marketplaceId
 */
export function isEUAmazonRealm(marketplaceId) {
    return EU_MARKETPLACE_IDS.has(marketplaceId);
}
export var SITE = {
    beta: 'AACChrome.Beta',
    gamma: 'AACChrome.Gamma',
    prod: 'AACChrome.Prod',
};
